export const Breakpoints: { [key: string]: number } = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
};

export const BreakpointsInPx: { [key: string]: string } = {
  xs: `${Breakpoints.xs}px`,
  sm: `${Breakpoints.sm}px`,
  md: `${Breakpoints.md}px`,
  lg: `${Breakpoints.lg}px`,
  xl: `${Breakpoints.xl}px`,
  xxl: `${Breakpoints.xxl}px`,
};
